<template>
  <div class="zm-time-spinner" :class="{ 'has-seconds': showSeconds }">
    <template v-if="!arrowControl">
      <zm-scrollbar
        @mouseenter.native="emitSelectRange('hours')"
        @mousemove.native="adjustCurrentSpinner('hours')"
        class="zm-time-spinner__wrapper"
        wrap-style="max-height: inherit;"
        view-class="zm-time-spinner__list"
        noresize
        tag="ul"
        ref="hours">
        <li
          @click="handleClick('hours', { value: hour, disabled: disabled })"
          v-for="(disabled, hour) in hoursList"
          :key="hour"
          class="zm-time-spinner__item"
          :class="{ 'active': hour === hours, 'disabled': disabled }">{{ ('0' + (amPmMode ? (hour % 12 || 12) : hour
          )).slice(-2) }}{{ amPm(hour) }}
        </li>
      </zm-scrollbar>
      <zm-scrollbar
        @mouseenter.native="emitSelectRange('minutes')"
        @mousemove.native="adjustCurrentSpinner('minutes')"
        class="zm-time-spinner__wrapper"
        wrap-style="max-height: inherit;"
        view-class="zm-time-spinner__list"
        noresize
        tag="ul"
        ref="minutes">
        <li
          @click="handleClick('minutes', { value: key, disabled: false })"
          v-for="(minute, key) in 60"
          :key="minute"
          class="zm-time-spinner__item"
          :class="{ 'active': key === minutes }">{{ ('0' + key).slice(-2) }}
        </li>
      </zm-scrollbar>
      <zm-scrollbar
        v-show="showSeconds"
        @mouseenter.native="emitSelectRange('seconds')"
        @mousemove.native="adjustCurrentSpinner('seconds')"
        class="zm-time-spinner__wrapper"
        wrap-style="max-height: inherit;"
        view-class="zm-time-spinner__list"
        noresize
        tag="ul"
        ref="seconds">
        <li
          @click="handleClick('seconds', { value: key, disabled: false })"
          v-for="(second, key) in 60"
          class="zm-time-spinner__item"
          :class="{ 'active': key === seconds }"
          :key="key">{{ ('0' + key).slice(-2) }}
        </li>
      </zm-scrollbar>
    </template>
    <template v-if="arrowControl">
      <div
        @mouseenter="emitSelectRange('hours')"
        class="zm-time-spinner__wrapper is-arrow">
        <button
          type="button"
          @click="increase"
          tabindex="-1"
          @focus="currentScrollbar='hours'"
          :aria-label="getAriaLabel('hours', 1)"
          class="zm-time-spinner__arrow zm-icon-up"></button>
        <button
          type="button"
          @click="decrease"
          tabindex="-1"
          @focus="currentScrollbar='hours'"
          :aria-label="getAriaLabel('hours', -1)"
          class="zm-time-spinner__arrow zm-icon-down"></button>
        <ul class="zm-time-spinner__list" ref="hours">
          <li
            class="zm-time-spinner__item"
            :class="{ 'active': hour === hours, 'disabled': hoursList[hour] }"
            v-for="(hour, key) in arrowHourList"
            :key="key">
            <!--{{ hour === undefined ? '' : ('0' + (amPmMode ? (hour % 12 || 12) : hour )).slice(-2) + amPm(hour) }}-->
            {{ hour === undefined ? '' : ('0' + (amPmMode ? ( hour === 24 ? 12 : (hour === 12 ? 12 : (hour % 12)) ) :
            hour )).slice(-2) }}
          </li>
        </ul>
      </div>
      <div
        @mouseenter="emitSelectRange('minutes')"
        class="zm-time-spinner__wrapper time-spinner-minutes-col is-arrow">
        <button
          type="button"
          @click="increase"
          tabindex="-1"
          @focus="currentScrollbar='minutes'"
          :aria-label="getAriaLabel('minutes', 1)"
          class="zm-time-spinner__arrow zm-icon-up"></button>
        <button
          type="button"
          @click="decrease"
          tabindex="-1"
          @focus="currentScrollbar='minutes'"
          :aria-label="getAriaLabel('minutes', -1)"
          class="zm-time-spinner__arrow zm-icon-down"></button>
        <ul class="zm-time-spinner__list" ref="minutes">
          <li
            class="zm-time-spinner__item"
            :class="{ 'active': minute === minutes }"
            v-for="(minute, key) in arrowMinuteList"
            :key="key">
            {{ minute === undefined ? '' : ('0' + minute).slice(-2) }}
          </li>
        </ul>
      </div>
      <div
        @mouseenter="emitSelectRange('seconds')"
        class="zm-time-spinner__wrapper time-spinner-seconds-col is-arrow"
        v-if="showSeconds">
        <button
          type="button"
          @click="increase"
          tabindex="-1"
          @focus="currentScrollbar='seconds'"
          :aria-label="getAriaLabel('seconds', 1)"
          class="zm-time-spinner__arrow zm-icon-up"></button>
        <button
          type="button"
          @click="decrease"
          tabindex="-1"
          @focus="currentScrollbar='seconds'"
          :aria-label="getAriaLabel('seconds', -1)"
          class="zm-time-spinner__arrow zm-icon-down"></button>
        <ul class="zm-time-spinner__list" ref="seconds">
          <li
            v-for="(second, key) in arrowSecondList"
            class="zm-time-spinner__item"
            :class="{ 'active': second === seconds }"
            :key="key">
            {{ second === undefined ? '' : ('0' + second).slice(-2) }}
          </li>
        </ul>
      </div>
      <div
        v-if="amPmMode"
        class="zm-time-spinner__mode-col">
        <span style="font-size: 12px">{{ amPm(hours) }}</span>
      </div>
    </template>
  </div>
</template>

<script type="text/babel">
  import { getRangeHours, modifyTime } from '../util';
  import ZmScrollbar from '../../scrollbar';
  import RepeatClick from '../../../directives/repeat-click';

  export default {
    components: {ZmScrollbar},

    directives: {
      repeatClick: RepeatClick
    },

    props: {
      date: {},
      defaultValue: {}, // reserved for future use
      showSeconds: {
        type: Boolean,
        default: true
      },
      arrowControl: {
        type: Boolean,
        default: true
      },
      amPmMode: {
        type: String,
        default: '' // 'a': am/pm; 'A': AM/PM
      },
      ariaLabelTitle: {
        type: String,
        default: ''
      }
    },

    computed: {
      hours() {
        return this.date.getHours();
      },
      minutes() {
        return this.date.getMinutes();
      },
      seconds() {
        return this.date.getSeconds();
      },
      hoursList() {
        return getRangeHours(this.selectableRange);
      },
      arrowHourList() {
        // const hours = this.hours;
        return [this.hours];
        /* return [
          hours > 0 ? hours - 1 : undefined,
          hours,
          hours < 23 ? hours + 1 : undefined
        ]; */
      },
      arrowMinuteList() {
        // const minutes = this.minutes;
        return [this.minutes];
        /* return [
          minutes > 0 ? minutes - 1 : undefined,
          minutes,
          minutes < 59 ? minutes + 1 : undefined
        ];*/
      },
      arrowSecondList() {
        // const seconds = this.seconds;
        return [this.seconds];
        /* return [
          seconds > 0 ? seconds - 1 : undefined,
          seconds,
          seconds < 59 ? seconds + 1 : undefined
        ];*/
      }
    },

    data() {
      return {
        selectableRange: [],
        currentScrollbar: null
      };
    },

    mounted() {
      this.$nextTick(() => {
        !this.arrowControl && this.bindScrollEvent();
      });
    },

    methods: {
      increase() {
        this.scrollDown(1);
      },

      decrease() {
        this.scrollDown(-1);
      },
      getAriaLabel(label, step) {
        const hoursList = this.hoursList;
        let now = this[label];

        if (label === 'hours') {
          let total = Math.abs(step);
          step = step > 0 ? 1 : -1;
          let length = hoursList.length;
          while (length-- && total) {
            now = (now + step + hoursList.length) % hoursList.length;
            if (hoursList[now]) {
              continue;
            }
            total--;
          }
          if (hoursList[now]) return;
        } else {
          now = (now + step + 60) % 60;
        }
        let offsetDate = '';
        switch (label) {
          case 'hours':
            offsetDate = modifyTime(this.date, now, this.minutes, this.seconds);
            break;
          case 'minutes':
            offsetDate = modifyTime(this.date, this.hours, now, this.seconds);
            break;
          case 'seconds':
            offsetDate = modifyTime(this.date, this.hours, this.minutes, now);
            break;
        }
        let res = this.getDisplayTime(offsetDate);
        return (this.ariaLabelTitle ? (this.ariaLabelTitle + ', ') : '') + res;
      },
      getDisplayTime(date) {
        const h = date.getHours();
        const m = date.getMinutes();
        const s = date.getSeconds();
        let res = '';
        res = ('0' + (this.amPmMode ? (h === 24 ? 12 : (h === 12 ? 12 : (h % 12))) : h)).slice(-2);
        res += ':';
        res += ('0' + m).slice(-2);
        if (this.showSeconds) {
          res += ':' + ('0' + s).slice(-2);
        }
        res += this.amPmMode ? this.amPm(h) : '';
        return res;
      },
      modifyDateField(type, value) {
        switch (type) {
          case 'hours':
            this.$emit('change', modifyTime(this.date, value, this.minutes, this.seconds));
            break;
          case 'minutes':
            this.$emit('change', modifyTime(this.date, this.hours, value, this.seconds));
            break;
          case 'seconds':
            this.$emit('change', modifyTime(this.date, this.hours, this.minutes, value));
            break;
        }
      },

      handleClick(type, {value, disabled}) {
        if (!disabled) {
          this.modifyDateField(type, value);
          this.emitSelectRange(type);
          this.adjustSpinner(type, value);
        }
      },

      emitSelectRange(type) {
        if (type === 'hours') {
          this.$emit('select-range', 0, 2);
        } else if (type === 'minutes') {
          this.$emit('select-range', 3, 5);
        } else if (type === 'seconds') {
          this.$emit('select-range', 6, 8);
        }
        this.currentScrollbar = type;
      },

      bindScrollEvent() {
        const bindFuntion = (type) => {
          this.$refs[type].wrap.onscroll = (e) => {
            // TODO: scroll is emitted when set scrollTop programatically
            // should find better solutions in the future!
            this.handleScroll(type, e);
          };
        };
        bindFuntion('hours');
        bindFuntion('minutes');
        bindFuntion('seconds');
      },

      handleScroll(type) {
        const value = Math.min(Math.floor((this.$refs[type].wrap.scrollTop - (this.scrollBarHeight(type) * 0.5 - 10) / this.typeItemHeight(type) + 3) / this.typeItemHeight(type)), (type === 'hours' ? 23 : 59));
        this.modifyDateField(type, value);
      },

      // NOTE: used by datetime / date-range panel
      //       renamed from adjustScrollTop
      //       should try to refactory it
      adjustSpinners() {
        this.adjustSpinner('hours', this.hours);
        this.adjustSpinner('minutes', this.minutes);
        this.adjustSpinner('seconds', this.seconds);
      },

      adjustCurrentSpinner(type) {
        this.adjustSpinner(type, this[type]);
      },

      adjustSpinner(type, value) {
        if (this.arrowControl) return;
        const el = this.$refs[type].wrap;
        if (el) {
          el.scrollTop = Math.max(0, value * this.typeItemHeight(type));
        }
      },

      scrollDown(step) {
        if (!this.currentScrollbar) {
          this.emitSelectRange('hours');
        }

        const label = this.currentScrollbar;
        const hoursList = this.hoursList;
        let now = this[label];

        if (this.currentScrollbar === 'hours') {
          let total = Math.abs(step);
          step = step > 0 ? 1 : -1;
          let length = hoursList.length;
          while (length-- && total) {
            now = (now + step + hoursList.length) % hoursList.length;
            if (hoursList[now]) {
              continue;
            }
            total--;
          }
          if (hoursList[now]) return;
        } else {
          now = (now + step + 60) % 60;
        }
        this.modifyDateField(label, now);
        this.adjustSpinner(label, now);
      },
      amPm(hour) {
        let shouldShowAmPm = this.amPmMode.toLowerCase() === 'a';
        if (!shouldShowAmPm) return '';
        let isCapital = this.amPmMode === 'A';
        let content = (hour < 12) ? ' am' : ' pm';
        if (isCapital) content = content.toUpperCase();
        return content;
      },
      typeItemHeight(type) {
        return this.$refs[type].$el.querySelector('li').offsetHeight;
      },
      scrollBarHeight(type) {
        return this.$refs[type].$el.offsetHeight;
      }
    }
  };
</script>

<style lang="scss">
  @import "../../../scss/common/var";
  @import "../../../scss/mixins/mixins";

  @include b(time-spinner) {
    display: flex;

    &.has-seconds {
      .zm-time-spinner__wrapper {
        width: 33.3%;
      }
      .time-spinner-minutes-col {
        .zm-time-spinner__item.active:not(.disabled) {
          &:after {
            display: block;
          }
        }
      }
    }
    @include e(mode-col) {
      flex: 1;
      align-self: center;
    }
    @include e(wrapper) {
      max-height: 190px;
      overflow: hidden;
      display: inline-block;
      width: 56px;
      vertical-align: top;
      position: relative;

      & .zm-scrollbar__wrap:not(.zm-scrollbar__wrap--hidden-default) {
        padding-bottom: 15px;
        overflow-x: hidden;
      }

      @include when(arrow) {
        box-sizing: border-box;
        text-align: center;
        overflow: hidden;

        /*.zm-time-spinner__list {
          transform: translateY(-32px);
        }*/

        .zm-time-spinner__item:hover:not(.disabled):not(.active) {
          background: $--color-white;
          cursor: default;
        }
        .zm-time-spinner__item.active:after {
          content: ':';
          position: absolute;
          right: 0;
          top: 0;
        }
      }
      &.time-spinner-minutes-col {
        .zm-time-spinner__item.active:not(.disabled) {
          &:after {
            display: none;
          }
        }
      }
      &.time-spinner-seconds-col {
        .zm-time-spinner__item.active:not(.disabled) {
          &:after {
            display: none;
          }
        }
      }
    }

    @include e(arrow) {
      font-size: 20px;
      color: $--color-primary;
      position: absolute;
      left: 50%;
      margin-left: -12px;
      width: 24px;
      z-index: $--index-normal;
      text-align: center;
      height: 24px;
      line-height: 24px;
      cursor: pointer;
      background-color: transparent;
      border: none;
      padding: 0;
      &:hover {
        color: $--color-border-primary;
      }
      &:hover,
      &:focus {
        outline: none;
        border-radius: 50%;
        box-shadow: 0 0 0 2px $--color-border-primary;
      }
      &.zm-icon-up {
        top: 10px;
      }

      &.zm-icon-down {
        bottom: 10px;
      }
    }

    @include e(input) {
      &.zm-input {
        width: 70%;

        .zm-input__inner {
          padding: 0;
          text-align: center;
        }
      }
    }

    @include e(list) {
      padding: 0;
      margin: 0;
      list-style: none;
      text-align: center;

      &::after,
      &::before {
        content: '';
        display: block;
        width: 100%;
        height: 74px;
      }
    }

    @include e(item) {
      height: 32px;
      line-height: 32px;
      font-size: 12px;
      color: $--color-text-primary;
      opacity: 0.75;

      &:hover:not(.disabled):not(.active) {
        background: $--background-color-base;
        cursor: pointer;
      }

      &.active:not(.disabled) {
        color: $--color-text-primary;
        font-weight: bold;
        font-size: 16px;
        opacity: 1;
        position: relative;
      }

      &.disabled {
        color: $--color-text-placeholder;
        cursor: not-allowed;
      }
    }
  }
</style>
